/**
 * Zeitformatierung — einzige Quelle der Wahrheit für prep_time / cook_time.
 * DB und API liefern Integer (Minuten). Dieses Modul formatiert für die Anzeige
 * und parst Freitext-Eingaben des Users zurück zu Integer.
 */

/**
 * Formatiert Minuten als lesbaren String.
 * @param {number|null} minutes
 * @returns {string}  z.B. "30 Min.", "1 Std. 30 Min.", ""
 */
export function formatTime(minutes) {
  if (!minutes || minutes <= 0) return '';
  const m = Math.round(minutes);
  if (m < 60) return `${m} Min.`;
  const h = Math.floor(m / 60);
  const rest = m % 60;
  return rest === 0 ? `${h} Std.` : `${h} Std. ${rest} Min.`;
}

/**
 * Parst Freitext-Eingabe des Users → Integer (Minuten).
 * Akzeptiert: "30", "30 Min", "1h30", "1:30", "1 Stunde 30 Minuten"
 * @param {string|number} raw
 * @returns {number}  0 wenn nicht parsebar
 */
export function parseTimeInput(raw) {
  if (!raw && raw !== 0) return 0;
  if (typeof raw === 'number') return raw > 0 ? Math.round(raw) : 0;
  const s = String(raw).trim().toLowerCase();
  if (!s) return 0;

  // "1h30" oder "1:30" oder "1 Std. 30 Min."
  const hm = s.match(/(\d+)\s*(?:h|:)\s*(\d+)/) ||
             s.match(/(\d+)\s*(?:std|stunde|stunden)\S*\s+(\d+)/);
  if (hm) return parseInt(hm[1]) * 60 + parseInt(hm[2]);

  // "1.5 Std." → 90
  const hDec = s.match(/(\d+\.\d+)\s*(?:std|stunde|stunden|h)\b/);
  if (hDec) return Math.round(parseFloat(hDec[1]) * 60);

  // "2 Std." → 120
  const hOnly = s.match(/(\d+)\s*(?:std|stunde|stunden|h)\b/);
  if (hOnly) return parseInt(hOnly[1]) * 60;

  // "30 Min." oder "30" → 30
  const mOnly = s.match(/(\d+)/);
  if (mOnly) return parseInt(mOnly[1]);

  return 0;
}
